import React, { useCallback } from "react";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  getFromLocalStorage,
  STORAGE_KEYS,
} from "../../../Utils/Helper/LocalStorage";

function buildOrgPath(path, orgSlug) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const loggedInUser = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);
  const slug =
    orgSlug ||
    loggedInUser?.slug ||
    loggedInUser?.tenantSlug ||
    loggedInUser?.tenant_slug ||
    null;
  return slug ? `/${slug}${normalizedPath}` : normalizedPath;
}

export function useNavigateToAccountDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { orgSlug } = useParams();

  return useCallback(
    (accountId, accountName) => {
      if (!accountId) return;
      navigate(buildOrgPath(`/account-workspace/${accountId}`, orgSlug), {
        state: {
          from: location.pathname + location.search,
          fromLabel: "Relationships",
        },
      });
    },
    [navigate, location.pathname, location.search, orgSlug]
  );
}

export function AccountDetailsSetupMessage({
  accountId,
  className = "text-sm text-gray-600",
}) {
  const navigateToAccountDetails = useNavigateToAccountDetails();

  return (
    <p className={className}>
      Add account team, executive team, and customer contacts on{" "}
      <button
        type="button"
        className="font-semibold text-purple-600 underline hover:text-purple-800"
        onClick={() => navigateToAccountDetails(accountId)}
      >
        Account Details
      </button>{" "}
      before mapping coverage.
    </p>
  );
}
